/**
 * 复制 HTML 内容到剪贴板
 * @param rawHtmlContent 要复制的 HTML 内容
 */
export async function copyHtml(rawHtmlContent: string) {
  if (!navigator.clipboard) {
    console.log('您的浏览器不支持剪贴板功能。');
    return;
  }
  try {
    const fullHtmlSnippet = `<meta http-equiv="Content-Type" content="text/html; charset=utf-8">${rawHtmlContent}`;
    const blobHtml = new Blob([fullHtmlSnippet], { type: 'text/html' });
    const blobText = new Blob([rawHtmlContent], { type: 'text/plain' });
    const clipboardItem = new ClipboardItem({ 'text/html': blobHtml, 'text/plain': blobText });
    await navigator.clipboard.write([clipboardItem]);
  } catch (err) {
    console.error('复制 HTML 失败:', err);
    throw err;
  }
}